export enum PhoneWidgetEvent {
  PhoneWidgetStartCalling = 'phone-widget-start-calling',
  PhoneWidgetStopCalling = 'phone-widget-stop-calling',
  PhoneWidgetDisconnect = 'phone-widget-disconnect',
}
